import { BrowserRouter, Switch, Route } from "react-router-dom";

// Helper Components
import Sidebar from "../components/sidebar";

// Dashboard Components
import Dashboard from "../source/Dashboard";
import Proxy from "../source/Proxy";
import Pricing from "../source/Pricing";
import Invoices from "../source/Invoices";
import ViewInvoice from "../source/ViewInvoice";
import Settings from "../source/Settings";
import FAQs from "../source/Faqs";

// PRODUCTS
import DatacenterProduct from "../source/Products/Datacenter";
import ISPProduct from "../source/Products/ISP";
import IPv6Product from "../source/Products/IPv6";
// import ResidentialProduct from "../source/Products/Residential";
import PremiumResidentialProduct from "../source/Products/PremiumResidential";

// PURCHASE
import DatacenterPurchase from "../source/Purchase/Datacenter";
import ISPPurchase from "../source/Purchase/ISP";
import IPv6Purchase from "../source/Purchase/IPv6";
// import ResidentialPurchase from "../source/Purchase/Residential";
import PremiumResidentialPurchase from "../source/Purchase/PremiumResidential";
import Balance from "../source/Balance";

export default function AuthRouter() {
  document.body.classList.remove("d-flex-grid");
  document.body.classList.remove("bg-auth");
  // document.body.classList.remove("border-primary");
  return (
    <BrowserRouter>
      <Sidebar />
      <Switch>
        {/* PRODUCTS */}
        <Route path="/product/datacenter" component={DatacenterProduct} />
        <Route path="/product/isp" component={ISPProduct} />
        <Route path="/product/ipv6" component={IPv6Product} />
        {/* <Route path="/product/residential" component={ResidentialProduct} /> */}
        <Route
          path="/product/premium-residential"
          component={PremiumResidentialProduct}
        />

        {/* PURCHASE */}
        <Route path="/purchase/datacenter" component={DatacenterPurchase} />
        <Route path="/purchase/isp" component={ISPPurchase} />
        <Route path="/purchase/ipv6" component={IPv6Purchase} />
        {/* <Route path="/purchase/residential" component={ResidentialPurchase} /> */}
        <Route
          path="/purchase/premium-residential"
          component={PremiumResidentialPurchase}
        />

        <Route path="/balance" component={Balance} />
        <Route path="/faqs" component={FAQs} />
        <Route path="/settings" component={Settings} />
        <Route path="/invoice/:invoice_id" component={ViewInvoice} />
        <Route path="/invoices" component={Invoices} />
        <Route path="/pricing" component={Pricing} />
        <Route path="/proxy" component={Proxy} />
        <Route path="/" component={Dashboard} />
      </Switch>
    </BrowserRouter>
  );
}
